








import Vue, { PropType } from "vue";
import log from "loglevel";

import { PostIssueTrialRequest } from "@/containers/trialCampaignRegister/api";
import { PostIssueTrialResponse } from "@/containers/trialCampaignRegister/api";

export interface TrialCampaignRegisterProps {
  returnUrl: string;
  deviceId: string;
  deviceEnv: string;
  deviceModel: string;
  productCode: string;
  campaignCode: string;
  postIssueTrial: any;
  waitingTime: number;
}

export interface TrialCampaignRegisterData {
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-trial-campaign-register",
  props: {
    returnUrl: {
      type: String as PropType<TrialCampaignRegisterProps["returnUrl"]>,
      default: ""
    },
    deviceId: {
      type: String as PropType<TrialCampaignRegisterProps["deviceId"]>,
      default: ""
    },
    deviceEnv: {
      type: String as PropType<TrialCampaignRegisterProps["deviceEnv"]>,
      default: ""
    },
    deviceModel: {
      type: String as PropType<TrialCampaignRegisterProps["deviceModel"]>,
      default: ""
    },
    productCode: {
      type: String as PropType<TrialCampaignRegisterProps["productCode"]>,
      default: ""
    },
    campaignCode: {
      type: String as PropType<TrialCampaignRegisterProps["campaignCode"]>,
      default: ""
    },
    waitingTime: {
      type: Number as PropType<TrialCampaignRegisterProps["waitingTime"]>,
      default: 0
    },

    // actionsToProps
    postIssueTrial: {
      type: Function as PropType<TrialCampaignRegisterProps["postIssueTrial"]>,
      default: () => {}
    }
  },
  data(): TrialCampaignRegisterData {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.executionPostIssueTrial();
  },
  methods: {
    async executionPostIssueTrial() {
      const requestData = {
        deviceId: this.deviceId,
        deviceEnv: this.deviceEnv,
        deviceModel: this.deviceModel,
        productCode: this.productCode,
        campaignCode: this.campaignCode
      } as PostIssueTrialRequest;

      try {
        const res: PostIssueTrialResponse = await this.postIssueTrial(
          requestData
        );
        this.isComplete = true;
        window.location.href = this.returnUrl + "?serial=" + res.serial;
      } catch (error) {
        log.error(error);
        window.location.href = this.returnUrl;
        throw error;
      }
    }
  }
});
